import { Injectable, NgZone, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import "rxjs/add/observable/of";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import { environment } from '../../environments/environment';
import { PROD_API_URL, DEV_API_URL } from './global-vars';
import Talk from "talkjs";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/* Interfaces */
export interface IInbox {
  id: string;
  name: string;
  email: string;
  photoUrl: string;
  signature: string;
  session: Talk.Session;
  unread: number;
  last_message: {
    text: string; 
    from: string;
    conversation_id: string;
  };
}

@Injectable()
export class MessengerService {
  api: string = (isDevMode()) ? DEV_API_URL : PROD_API_URL;
  show: boolean = false;
  unread: number = 0;
  inboxes: IInbox[] = null;
  ready: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {
    // this.init();
  }

  update_inboxes(): Observable<IInbox[]> {
    return this.http.get<{inboxes: IInbox[]}>(`${this.api}api/users/messenger/`)
    .catch(err => {
      console.error('Error -> Updating inboxes');
      return Observable.throw(err);
    })
    .do(response => this.inboxes = response.inboxes)
    .do(response => this.show = (response.inboxes.length > 0) ? true : false)
    .map(response => response.inboxes.map(inbox => {
      inbox.photoUrl = (inbox.photoUrl) ? inbox.photoUrl : 'assets/avatar-default.png';
      return inbox;
    }));
  }

  get_inbox_by_id(id: string) {
    let inbox = this.inboxes.filter(item => item.id == id);
    return (inbox[0]) ? inbox[0] : null;
  }

  update_unread(){
    let unread_count: number = 0;
    for (let inbox of this.inboxes) unread_count += inbox.unread;
    this.unread = unread_count;
  }

  init(){
    this.update_inboxes().subscribe(value => {
      Talk.ready.then(() => {
        for (let inbox of this.inboxes) {
          inbox.session = new Talk.Session({
            appId: environment.TALKJS_APP_ID,
            me: new Talk.User({id: inbox.id, name: inbox.name, photoUrl: inbox.photoUrl, role: "account_manager"}),
            signature: inbox.signature
          });


          inbox.session.unreads.on('change', (value: Talk.UnreadMessage[]) => {
            this.inboxes.map(item => {
              if (item.id == inbox.id) {
                item.unread = value.length;
                if (value[0]) {
                  let last = value[0].lastMessage;
                  item.last_message = {
                    text: last.body, 
                    from: (last.sender && last.sender.name) ? last.sender.name : 'Yoola',
                    conversation_id: last.conversation.id
                  };
                }
              }
              return item;
            });

            this.update_unread();
            this.ready.next(true);
          });
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/messenger.service.ts